import { UPDATE_EXISTING_TEST_STATUS } from '../constants/actionTypes'

export default (state = false, action) => {
    switch (action.type) {
        case UPDATE_EXISTING_TEST_STATUS:
            return true
        default:
            return state
    }
}
